import React from 'react';

import AnimateHeight from 'react-animate-height';
import { FormattedMessage } from 'react-intl';

import DiffInformationBanner from './diff-information-banner';
import diffMessages from './diff.i18n';

type Props = {
  visible: boolean;
  showComments: () => void;
};
export const HiddenCommentsBanner = React.memo(
  ({ visible, showComments }: Props) => (
    <AnimateHeight duration={250} animateOpacity height={!visible ? 'auto' : 0}>
      <DiffInformationBanner>
        <FormattedMessage {...diffMessages.commentsHidden} />
        <button onClick={showComments}>
          <FormattedMessage {...diffMessages.showComments} />
        </button>
      </DiffInformationBanner>
    </AnimateHeight>
  )
);

export default HiddenCommentsBanner;
